import React from "react";

export default function SquareStripe() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 66 64"
    >
      <path
        fill="#000"
        d="M0 0h4.571v9.143H0zM30.476 0h4.571v13.714h-4.571zM18.285 4.571V.001h4.571v4.57zM36.571 45.714v-4.571h10.667v4.57zM24.381 50.286v-4.571h10.667v4.57zM54.858 50.286v-4.571h10.667v4.571zM0 22.857v-4.57h4.571v4.57zM6.095 32v-4.57h4.571V32zM18.286 32v-4.571h4.57v4.57zM12.19 45.714v-4.571h4.571v4.57zM36.572 59.428v-4.57h10.667v4.57zM18.286 64v-4.571h10.667v4.57zM12.191 59.428v-4.57h4.571v4.57zM54.857 4.572V0h10.667v4.57zM30.476 22.857v-4.57h4.571v4.57zM42.667 9.143V4.572h4.57v4.57zM0 36.572V32h4.57v4.57zM0 50.286v-4.571h4.571v4.57zM30.476 41.143V32h4.571v9.143zM42.666 36.571v-9.143h4.571v9.143zM54.858 27.429v-9.143h4.57v9.143zM60.953 41.142V32h4.57v9.143zM60.952 64v-9.144h4.571V64zM6.095 4.571h4.571v18.286H6.095zM6.095 36.571h4.571v18.286H6.095zM6.095 59.429h4.571V64H6.095zM24.381 4.571h4.571v18.286h-4.571zM18.286 45.714h4.571v9.143h-4.571zM36.572 18.286h4.571V32h-4.571zM48.762 9.143h4.571v13.714h-4.571zM24.381 32h4.571v4.571h-4.571zM12.191 4.571h4.571V32h-4.571zM48.762 27.429h4.571V64h-4.571z"
      />
    </svg>
  );
}
